module.exports = __webpack_public_path__ + "media/images/covers/discover-your-future/discover-bg-f45ac64f1cf698d8ba093c8528bf8d31.jpg";